<template>
  <div class="tronlink-import-container">
    <div class="tronlink-import-card">
      <h1 class="title">{{ $t('tronlinkImport.title') }}</h1>
      
      <p class="description">
        {{ $t('tronlinkImport.description') }}
      </p>
      
      <button class="import-button" @click="handleImport">
        {{ $t('common.startImport') }}
      </button>
    </div>
  </div>
</template>

<script>
import { closeIfMnemonicAlreadySaved } from '../utils/mnemonicImport';

export default {
  name: 'TronLinkImport',
  mounted() {
    closeIfMnemonicAlreadySaved(this, this.$route);
  },
  methods: {
    handleImport() {
      const query = { ...this.$route.query };
      this.$router.push({ path: '/tronlink-wallet-import', query });
    }
  }
}
</script>

<style scoped>
.tronlink-import-container {
  min-height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
}

.tronlink-import-card {
  background: white;
  border-radius: 16px;
  padding: 35px 40px;
  max-width: 480px;
  width: 100%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.4s ease-out;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.title {
  font-size: 22px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 20px 0;
  text-align: center;
  letter-spacing: 0.5px;
}

.description {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  text-align: center;
  margin: 0 0 28px 0;
}

.import-button {
  width: 100%;
  background: #1a1a1a;
  color: white;
  border: none;
  border-radius: 12px;
  padding: 16px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(26, 26, 26, 0.3);
}

.import-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(26, 26, 26, 0.4);
  background: #2a2a2a;
}

.import-button:active {
  transform: translateY(0);
  box-shadow: 0 2px 6px rgba(26, 26, 26, 0.3);
}

/* 移动端适配 */
@media (max-width: 480px) {
  .tronlink-import-card {
    padding: 30px 28px;
  }
  
  .title {
    font-size: 20px;
  }
  
  .description {
    font-size: 13px;
  }
}
</style>

